import { useMutation } from "@tanstack/react-query";
import axios from "axios";
import apiDal from "../config/apiDal";
import { UserData } from "../types";

type LoginPayload = {
	username: string;
	password: string;
};

export const useLogin = () => {
	return useMutation<UserData, Error, LoginPayload>({
		mutationFn: async ({ username, password }) => {
			const response = await apiDal.post<UserData>("/users/login", {
				username,
				password,
			});

			return response.data;
		},
	});
};

export default useLogin;
